export default "__VITE_ASSET__B_9wZf4O__"